//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dialogForm from './components/index';
import calendarBar from '@/views/user/calendar/components/calendarBar';
import checkDialog from '@/views/user/calendar/components/checkDialog';
import defaultPage from '@/components/common/defaultPage';
import { dealtScheduleListApi, dealtScheduleRecordApi } from '@/api/user';
export default {
  name: 'WorkDealt',
  components: {
    calendarBar: calendarBar,
    dialogForm: dialogForm,
    checkDialog: checkDialog,
    defaultPage: defaultPage
  },
  data: function data() {
    return {
      formBoxConfig: {},
      rolesConfig: [],
      dayArray: [],
      repeatData: {},
      itemArray: [],
      types: [],
      time: this.$moment(this.time).format('yyyy-MM-DD'),
      dateTime: null,
      complete: true
    };
  },
  methods: {
    handleDate: function handleDate(data) {
      this.time = data.time;
      var t = this.$moment(new Date()).format('HH:mm:ss');
      this.dateTime = data.time + ' ' + t;
      this.types = data.type;
      this.getList();
    },
    addTask: function addTask() {
      this.formBoxConfig = {
        title: this.$t('calendar.addtask'),
        edit: false,
        data: {
          types: 'personal'
        },
        width: '500px',
        date: this.dateTime
      };
      this.$refs.dialogForm.openBox();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      var data = {
        types: this.types,
        time: this.time,
        period: 0
      };
      dealtScheduleListApi(data).then(function (res) {
        _this.dayArray = res.data[0].list;
      });
    },
    setScheduleRecord: function setScheduleRecord(item) {
      var data = {
        time: this.time,
        status: item.finish === 0 ? 1 : 0
      };
      this.scheduleRecord(item.id, data);
    },
    // 提醒状态
    scheduleRecord: function scheduleRecord(id, data) {
      var _this2 = this;
      dealtScheduleRecordApi(id, data).then(function (res) {
        _this2.handleList();
      });
    },
    handleRepeatData: function handleRepeatData(data) {
      if (data.type === 1) {
        this.handleList();
      } else {
        this.formBoxConfig = {
          title: this.$t('calendar.edittask'),
          edit: true,
          width: '500px',
          data: this.itemArray
        };
        this.$refs.dialogForm.openBox();
      }
    },
    handleList: function handleList() {
      this.getList();
      this.$emit('handDealt');
    },
    handleItemClick: function handleItemClick(item) {
      this.repeatData = {
        title: this.$t('calendar.checktask'),
        width: '480px',
        data: item
      };
      this.itemArray = item;
      this.$refs.repeatDialog.handleOpen();
    },
    addCompleteTask: function addCompleteTask() {
      this.complete = this.complete !== true;
    }
  }
};